import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Checkbox from 'components/form/Checkbox';
import RadioGroup from 'components/form/RadioGroup';

const MultipleChoice = ({ question }) => {
  const { question_possible_answers, question_settings } = question;

  return (
    <Box>
      <Typography variant="subtitle1" fontWeight={500}>
        {question.question_label}
      </Typography>
      <Typography paragraph color="text.secondary">
        Select from the following options
      </Typography>
      {question_settings.multipleChoice ? (
        <Grid container spacing={2}>
          {question_possible_answers.map((option) => (
            <Grid item xs={12} sm={6} key={option.id}>
              <Checkbox label={option.value} />
            </Grid>
          ))}
        </Grid>
      ) : (
        <RadioGroup
          options={question_possible_answers}
          valueKey="id"
          labelKey="value"
        />
      )}
    </Box>
  );
};

export default MultipleChoice;
